module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_113_12.16f04b27.pdf";